import * as React from "react";
import { ShowNotification } from "src/components/common/ShowNotification/ShowNotification";
import { IDocument } from "src/services/interfaces/IDocument";
import { ServiceContext } from "src/services/provider/Service.provider";
import PbrDocUploader from "../PbrDocUploaderTradeId/PbrDocUploader";
import { IUploadButton } from "./IUploadButton";

interface IDocumentUpload extends IDocument {
  tradeId: number;
}

export function UploadDocumentButton(props: IUploadButton) {
  const { documentService } = React.useContext(ServiceContext);

  async function handleSubmit(file: Omit<IDocumentUpload, "id" | "path">) {
    try {
      await documentService.putUploadGeneric(file).then(resp => {
        ShowNotification.Success("Registro salvo com sucesso", "O documento foi salvo com sucesso!");
        if (!props.dontReloadTrade) {
          props.reloadTrade(props.trade.id);
        }
      });
    } catch (error) {
      ShowNotification.Error("Ocorreu um erro", error.response.data.message);
    }
  }

  function handleChange(fileToUpload, idFromTrade) {
    props.setLoading(true);
    const documentUpload: Omit<IDocumentUpload, "id" | "path"> = {
      category: props.uploadCategory,
      tradeId: idFromTrade,
      storageType: props.storageType,
      file: fileToUpload.file,
      fileName: fileToUpload.name,
      uploadDate: new Date()
    };
    handleSubmit(documentUpload).finally(() => props.setLoading(false));
  }

  return (
    <PbrDocUploader
      disabled={props.isEnableAlways ? false : props.trade?.documentList?.find(element => element.category === props.uploadCategory) ? true : false}
      onChangeBase64={val => handleChange(val, props.trade.id)}
      setLoading={props.setLoading}
      hoverTextDisabled={props.hoverTextDisabled}
      hoverText={props.hoverText}
      title={props.title}
      showUploadList={false}
    />
  );
}



// WEBPACK FOOTER //
// ./src/components/Refatoracao/UploadDocument/UploadDocumentButton.tsx